
import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header"; 

const Layout = ({ children }) => {
  const location = useLocation();
  const noHeaderPaths = ["/admin-abhijan-login", "/admin-abhijan-home"];

  // Determine whether to show the header based on the current path
  const shouldShowHeader = !noHeaderPaths.includes(location.pathname);

  return (
    <div className='bg-[#1d0c39] bg-no-repeat bg-cover overflow-hidden'>
      <Header />
      {children}
    </div>
  );
};

export default Layout;
